import React, { useState } from 'react';
import './SideStepsPanel.scss';
import cn from 'classnames'
import { Icon } from '@finam/web-ui-kit/Input/Input.styles';
import { ArrowLeft, ArrowRight } from '@finam/web-ui-kit/Icons/Arrow';
import EnrollmentDatePanel from './EnrollmentDatePanel';
import ManagerContacts from './ManagerContacts';


interface ISidePanelProps {
    currentStep: number,
    currentMaxStep: number,
    onStepChange: (step: number) => void,
    slotId?: number;
    managerInfo?: { guid: string, telegram: string | undefined };
    emplManagerInfo?: { guid: string, telegram: string | undefined };
    meetingLink?: string;
}

interface IStepItem {
    number: number;
    description: string
}

const Steps: IStepItem[] = [
    { number: 1, description: 'Принятие оффера' },
    { number: 3, description: 'Выбор даты выхода' },
    { number: 4, description: 'Получение УНЭП' },
    { number: 5, description: 'Загрузка документов' },
    { number: 6, description: 'Познакомиться с коллегами' },
    { number: 7, description: 'Подписание документов' },
    { number: 8, description: 'Завершение' }
];

export const SideStepsPanel: React.FC<ISidePanelProps> = (props) => {
    const [open, setOpen] = useState<boolean>(false);


    const renderItem = (s: IStepItem, n: number) => {
        return <div className={cn('step-panel__step', { 'active': s.number <= props.currentMaxStep, 'selected': s.number == props.currentStep })}
            key={s.number}
            onClick={() => { if (s.number <= props.currentMaxStep) props.onStepChange(s.number); }}>
            <div className='step-panel_number'>{n}</div>
            <div className='step-panel_description'>{s.description}</div>
        </div>
    }

    const renderCurrentItem = () => {
        const currentStepIndex = Steps.findIndex(s => s.number == props.currentStep);
        return currentStepIndex > -1 ? renderItem(Steps[currentStepIndex], currentStepIndex + 1) : undefined;
    }

    return (
        <div className='step-panel__wrapper'>
            <input type='checkbox' id='openMenuCheck' checked={open} style={{ display: 'none' }} />
            <div className='step-panel__logo'><img /></div>
            <div className='step-panel-main'>
                <h4 className='step-panel__stepsHeader'>Этапы оформления</h4>
                <div className='step-panel___steps'>
                    {Steps.map((s, i) => renderItem(s, i + 1))}
                    {!!props.slotId && props.slotId > 0 && <EnrollmentDatePanel slotId={props.slotId} collapsed={!open} meetingLink={props.meetingLink} />}
                    <div className='managersContacts'>
                        {!!props.managerInfo?.guid && <ManagerContacts managerInfo={props.managerInfo} label="Ваш HR менеджер" collapsed={!open} />}
                        {!!props.emplManagerInfo?.guid && <ManagerContacts managerInfo={props.emplManagerInfo} label="Ваш оформляющий менеджер" collapsed={!open} />}
                    </div>
                    <div className='toggleBtn' onClick={_ => setOpen(true)}><ArrowRight /></div>
                </div>

                <div className={cn('step-panel-full___steps', { 'full': !!open })}>
                    {Steps.map((s, i) => renderItem(s, i + 1))}
                    {!!props.slotId && props.slotId > 0 && <EnrollmentDatePanel slotId={props.slotId} collapsed={!open} meetingLink={props.meetingLink} />}
                    <div className='managersContactsTitle'>Ваши менеджеры:</div>
                    <div className='managersContacts'>
                        {!!props.managerInfo?.guid && <ManagerContacts managerInfo={props.managerInfo} label="HR" collapsed={!open} />}
                        {!!props.emplManagerInfo?.guid && <ManagerContacts managerInfo={props.emplManagerInfo} label="Оформляющий" collapsed={!open} />}
                    </div>
                    <div className='toggleBtn' onClick={_ => setOpen(false)}><ArrowLeft /></div>
                </div>

            </div>
        </div>)
} 